import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import inflection from "inflection";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { getResources, translate } from "ra-core";
import DefaultIcon from "@material-ui/icons/ViewList";
//import CloudUpload from "@material-ui/icons/CloudUpload";
import Home from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { WithPermissions } from "react-admin";
import { Redirect } from "react-router-dom";
import { withRouter } from 'react-router-dom';

import DashboardMenuItem from "ra-ui-materialui/lib/layout/DashboardMenuItem";
import MenuItemLink from "ra-ui-materialui/lib/layout/MenuItemLink";
import Responsive from "ra-ui-materialui/lib/layout/Responsive";
import { DRAWER_WIDTH } from "ra-ui-materialui/lib/layout/Sidebar";

import UI_NAMES from './constants/ui.names'
import UI_CONTENT from './constants/ui.content'

const styles = {
  main: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: DRAWER_WIDTH
  }
};

const translatedResourceName = (resource, translate) =>
  translate(`resources.${resource.name}.name`, {
    smart_count: 2,
    _:
      resource.options && resource.options.label
        ? translate(resource.options.label, {
            smart_count: 2,
            _: resource.options.label
          })
        : inflection.humanize(inflection.pluralize(resource.name))
  });

// const isAdmin = permissions => {
//   return permissions === "admin";
// };

const isCoordinador = permissions => {
  return permissions === "coordinador";
};

const isEnfardador = permissions => {
  return permissions === "enfardador";
};


const isCartonero = permissions => {
  return permissions === "cartonero";
};

const isPesador = permissions => {
  return permissions === "pesador";
};

const isAuditor = permissions => {
  return permissions === "auditor";
};

const Menu = ({
  classes,
  className,
  dense,
  hasDashboard,
  onMenuClick,
  pathname,
  resources,
  translate,
  logout,
  ...rest
}) => (
  <WithPermissions
    render={({ permissions }) => {
      return (
        <div className={classnames(classes.main, className)} {...rest}>
          {hasDashboard && (
            <DashboardMenuItem
              primaryText={UI_CONTENT.HOME_MENU_ITEM}
              leftIcon={<Home />}
              onClick={onMenuClick}
              name={UI_NAMES.HOME_MENU_ITEM}
            />
          )}
          {resources
            .filter(r => r.hasList)
            .map(resource => {
              // Removes List Menu Item from the cartonero Menu.
              if (isCartonero(permissions)) return null;
              if (
                isCoordinador(permissions) &&
                resource.name === "coordinadores" &&
                resource.hasList
              )
                return null;
              if (
                isPesador(permissions) &&
                resource.name === "pesadores" && (
                  <Redirect to="/pesajes/create" />
                ) &&
                resource.hasList
              )
                return null;
              if (
                isAuditor(permissions) &&
                resource.name === "auditor" &&
                resource.hasList
              )
                return null;
              return (
                <MenuItemLink
                  key={resource.name}
                  to={`/${resource.name}`}
                  primaryText={translatedResourceName(resource, translate)}
                  leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                  onClick={onMenuClick}
                  dense={dense}
                  name={UI_NAMES.RESOURCE_VIEW_MENU_ITEM.with({ resourceName: resource.name, view: 'list' })}
                />
              );
            })}
          {isEnfardador(permissions) && (
            <MenuItemLink
              key="pesador-materiales"
              to="/pesaje-material/create"
              primaryText="Pesar materiales"
              leftIcon={<AddCircleIcon />}
              onClick={onMenuClick}
              dense={dense}
              name={UI_NAMES.RESOURCE_VIEW_MENU_ITEM.with({ resourceName: 'enfardador', view: 'create' })}
            />
          )}
          {/* isAdmin(permissions) && (
            <MenuItemLink
              key="operaciones"
              to="/operaciones/create"
              primaryText="Cargar Operaciones"
              leftIcon={<CloudUpload />}
              onClick={onMenuClick}
              dense={dense}
              name={UI_NAMES.RESOURCE_VIEW_MENU_ITEM.with({ resourceName: 'operaciones', view: 'create' })}
            />
          )*/}
          {isCoordinador(permissions) && (
            <MenuItemLink
              key="coordinador"
              to="/coordinadores/edit"
              primaryText="Modificar Contraseña"
              leftIcon={<SettingsIcon />}
              onClick={onMenuClick}
              dense={dense}
              name={UI_NAMES.RESOURCE_VIEW_MENU_ITEM.with({ resourceName: 'coordinadores', view: 'edit' })}
            />
          )}
          {isCartonero(permissions) && (
            <MenuItemLink
              key="cartonero"
              to="/recuperadores/edit"
              primaryText="Modificar Contraseña"
              leftIcon={<SettingsIcon />}
              onClick={onMenuClick}
              dense={dense}
              name={UI_NAMES.RESOURCE_VIEW_MENU_ITEM.with({ resourceName: 'recuperadores', view: 'edit' })}
            />
          )}

          <Responsive xsmall={logout} medium={null} />
        </div>
      );
    }}
  />
);

Menu.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  dense: PropTypes.bool,
  hasDashboard: PropTypes.bool,
  logout: PropTypes.element,
  onMenuClick: PropTypes.func,
  pathname: PropTypes.string,
  resources: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired
};

Menu.defaultProps = {
  onMenuClick: () => null
};

const mapStateToProps = state => ({
  resources: getResources(state),
  //pathname: state.routing.location.pathname // used to force redraw on navigation
});

const enhance = compose(
  withRouter,
  translate,
  connect(
    mapStateToProps,
    {}, // Avoid connect passing dispatch in props,
    null,
    {
      areStatePropsEqual: (prev, next) =>
        prev.resources.every(
          (value, index) => value === next.resources[index] // shallow compare resources
        ) && prev.pathname === next.pathname
    }
  ),
  withStyles(styles)
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/layout/Menu.js